import { render, staticRenderFns } from "./CheckinFieldsList.vue?vue&type=template&id=63c7bf7e&scoped=true&"
import script from "./CheckinFieldsList.vue?vue&type=script&lang=js&"
export * from "./CheckinFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./CheckinFieldsList.vue?vue&type=style&index=0&id=63c7bf7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7bf7e",
  null
  
)

export default component.exports